import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

import {ClassRecordTechniquesModel} from './ClassRecordTechniquesModel.js';
import {StudentAttendanceTable} from './classrecord_student_attendance/StudentAttendanceTable.js';
import {ClassRecordTechniquesEditor} from './ClassRecordTechniquesEditor.js';
import {ClassRecordDetailsEditor} from './ClassRecordDetailsEditor.js';
import {ClassRecordNavigationButtons} from './ClassRecordNavigationButtons.js';
import {DateToDayDisplay} from './DateToDayDisplay.js';

export class ClassRecordEditor {
	constructor(techniques, classRecordId, previousClassRecordId, nextClassRecordId) {
		let techniquesModel = new ClassRecordTechniquesModel(classRecordId);

		// let attendanceTypes = new AttendanceTypesModel(attendanceTypesArray);
		// let studentListEditor = new ClassRecordStudentListEditor(
		// 	document.getElementById('students-editor'),
		// 	classRecordId, attendanceTypes);

		if (document.getElementById(`students-editor`)) {
			// let attendanceTable = new StudentAttendanceTable(
			// 	document.getElementById('students-editor'),
			// 	classRecordId);

			// let attendanceTable = document.getElementById(`students-editor`);
		}

		if (document.getElementById(`techniques-editor`)) {
			console.log(`Found technqiues-editor= `, document.getElementById('techniques-editor'));
			new ClassRecordTechniquesEditor(
				document.getElementById('techniques-editor'),
				classRecordId, techniquesModel, techniques);
		} else {
			console.log(`Failed to find #technqiues-editor`);
		}

		new ClassRecordDetailsEditor(classRecordId);

		new DateToDayDisplay(document.getElementById('Date'), document.getElementById('dateDay'));

		if (document.getElementById(`techniques-editor-link`))
			new ClassRecordTabTitleCount(techniquesModel, 
				document.getElementById('techniques-editor-link'));

		if (document.getElementById('students-editor-link'))	
			new ClassRecordTabTitleCount(attendanceTable.presentModel(), 
			 	document.getElementById('students-editor-link'));

		document.getElementById('deleteClassRecordButton').addEventListener('click',
			function(evt) {
				evt.preventDefault();
				evt.stopPropagation();
				if (confirm('Deletion is permanent. Continue?')) {
					DojoDeshi.instance().RPC().DeleteClassRecord(classRecordId).then(
						function(res) {
							document.location='/classrecord/summary';
						},
						function(err) {
							console.error(err);
							alert('Failed to delete Class Record:' + err);
						}
					);
				}
			});
		new ClassRecordNavigationButtons(previousClassRecordId, nextClassRecordId);		
	}
}

window.ClassRecordEditor = ClassRecordEditor;